
<div class="card mb-3">
    <div class="p-scroller-header">
      <h3 class="h4 text-start">{{triageHistoryTitle}}</h3>
    </div>
    <p-scroller #sc [items]="triageItemsDisplaying"
                [itemSize]="100"
                styleClass="border-1 surface-border"
                [style]="{'height': '250px'}">
      <ng-template let-triageItem pTemplate="item">
        <dl class="m-2 border-bottom border-medium">
          <dt *ngIf="triageItem.CrimeGunTriageID">Triaged by {{ triageItem.CreatedByFirstName }} {{triageItem.CreatedByLastName }} ({{ triageItem.CreatedBy }}) on {{ triageItem.CreatedOn | utcToLocal:'MM/dd/yyyy  HH:mm'}} at {{ triageItem.TriageLevelName }}</dt>
          <dd>{{ triageItem.Comment }}</dd>
        </dl>
      </ng-template>
    </p-scroller>
</div>
